function LegalSection() {
  return (
    <section className="panel legal" id="legal">
      <div className="panel-head">
        <div>
          <p className="eyebrow">Site Notice</p>
          <h2>Privacy Policy & Terms</h2>
          <p className="sub small">Explains local data use, content standards, and responsibility boundaries</p>
        </div>
      </div>

      <div className="legal-block">
        <h3>Privacy Policy</h3>
        <ul>
          <li>This app is front-end only; no personal data is collected or uploaded.</li>
          <li>User-created content (entertainment lists, truth/dare, wheel, polls) stays in browser localStorage and can be cleared anytime.</li>
          <li>If analytics or ads are added later, we will provide prominent notice and consent options.</li>
        </ul>
      </div>

      <div className="legal-block">
        <h3>Terms of Use</h3>
        <ul>
          <li>Do not create or share illegal, violent, pornographic, hateful, discriminatory, or gambling-related content.</li>
          <li>Polls and questions must follow local laws and avoid violating privacy or copyright.</li>
          <li>Default samples are for demo only; you are responsible for your own custom content.</li>
          <li>The app is provided “as is.” To clear data, remove the site storage in your browser.</li>
        </ul>
      </div>
    </section>
  );
}

export default LegalSection;

